import Aplications from './Aplications';

export default Aplications;